export enum LanguageType {
  ZH = 'zh',
  EN = 'en',
}
